"use strict";
/**
 * @file Created on 27.05.2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../../core/model/data-dictionary/StructPropBuilder");

var NotificationDoc_1 = require("../NotificationDoc");
/**
 * @author Tomas Leity
 */


var NChangedProdThreshold =
/*#__PURE__*/
function (_NotificationDoc_1$No) {
  _inherits(NChangedProdThreshold, _NotificationDoc_1$No);

  /**
   * @param productId
   * @param productName
   * @param promoVolume
   * @param promoVolumeOld
   * @param promoVolumeAbsTh
   * @param promoVolumeRelTh
   * @param promoPrice
   * @param promoPriceOld
   * @param promoPriceAbsTh
   * @param promoPriceRelTh
   * @param promoPurchasePrice
   * @param promoPurchasePriceOld
   * @param promoPurchasePriceAbsTh
   * @param promoPurchasePriceRelTh
   * @param unitBackDiscount
   * @param unitBackDiscountOld
   * @param unitBackDiscountAbsTh
   * @param unitBackDiscountRelTh
   */
  function NChangedProdThreshold( // product
  productId, productName, // volume
  promoVolume, promoVolumeOld, promoVolumeAbsTh, promoVolumeRelTh, // price
  promoPrice, promoPriceOld, promoPriceAbsTh, promoPriceRelTh, // purchase price
  promoPurchasePrice, promoPurchasePriceOld, promoPurchasePriceAbsTh, promoPurchasePriceRelTh, // unit back discount
  unitBackDiscount, unitBackDiscountOld, unitBackDiscountAbsTh, unitBackDiscountRelTh) {
    var _this;

    _classCallCheck(this, NChangedProdThreshold);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(NChangedProdThreshold).call(this));
    _this.productId = productId;
    _this.productName = productName;
    _this.promoVolume = promoVolume;
    _this.promoVolumeOld = promoVolumeOld;
    _this.promoVolumeAbsTh = promoVolumeAbsTh;
    _this.promoVolumeRelTh = promoVolumeRelTh;
    _this.promoPrice = promoPrice;
    _this.promoPriceOld = promoPriceOld;
    _this.promoPriceAbsTh = promoPriceAbsTh;
    _this.promoPriceRelTh = promoPriceRelTh;
    _this.promoPurchasePrice = promoPurchasePrice;
    _this.promoPurchasePriceOld = promoPurchasePriceOld;
    _this.promoPurchasePriceAbsTh = promoPurchasePriceAbsTh;
    _this.promoPurchasePriceRelTh = promoPurchasePriceRelTh;
    _this.unitBackDiscount = unitBackDiscount;
    _this.unitBackDiscountOld = unitBackDiscountOld;
    _this.unitBackDiscountAbsTh = unitBackDiscountAbsTh;
    _this.unitBackDiscountRelTh = unitBackDiscountRelTh;
    return _this;
  }
  /**
   * Converter from data-dictionary representation
   */


  _createClass(NChangedProdThreshold, null, [{
    key: "fromDataDict",
    value: function fromDataDict(mat) {
      return new NChangedProdThreshold(mat.productId, mat.productName, mat.promoVolume, mat.promoVolumeOld, mat.promoVolumeAbsTh, mat.promoVolumeRelTh, mat.promoPrice, mat.promoPriceOld, mat.promoPriceAbsTh, mat.promoPriceRelTh, mat.promoPurchasePrice, mat.promoPurchasePriceOld, mat.promoPurchasePriceAbsTh, mat.promoPurchasePriceRelTh, mat.unitBackDiscount, mat.unitBackDiscountOld, mat.unitBackDiscountAbsTh, mat.unitBackDiscountRelTh);
    }
  }]);

  return NChangedProdThreshold;
}(NotificationDoc_1.NotificationDoc);

exports.NChangedProdThreshold = NChangedProdThreshold;

NChangedProdThreshold.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(NChangedProdThreshold.name);
  return {
    productId: builder.id('productId'),
    productName: builder.id('productName'),
    promoVolume: builder.bigNum('promoVolume'),
    promoVolumeOld: builder.opt(builder.bigNum('promoVolumeOld')),
    promoVolumeAbsTh: builder.opt(builder.num('promoVolumeAbsTh')),
    promoVolumeRelTh: builder.opt(builder.num('promoVolumeAbsTh')),
    promoPrice: builder.bigNum('promoPrice'),
    promoPriceOld: builder.opt(builder.bigNum('promoPriceOld')),
    promoPriceAbsTh: builder.opt(builder.num('promoPriceAbsTh')),
    promoPriceRelTh: builder.opt(builder.num('promoPriceAbsTh')),
    promoPurchasePrice: builder.opt(builder.bigNum('promoPurchasePrice')),
    promoPurchasePriceOld: builder.opt(builder.bigNum('promoPurchasePriceOld')),
    promoPurchasePriceAbsTh: builder.opt(builder.num('promoPurchasePriceAbsTh')),
    promoPurchasePriceRelTh: builder.opt(builder.num('promoPurchasePriceAbsTh')),
    unitBackDiscount: builder.opt(builder.bigNum('unitBackDiscount')),
    unitBackDiscountOld: builder.opt(builder.bigNum('unitBackDiscountOld')),
    unitBackDiscountAbsTh: builder.opt(builder.num('unitBackDiscountAbsTh')),
    unitBackDiscountRelTh: builder.opt(builder.num('unitBackDiscountAbsTh'))
  };
}();